import { render, staticRenderFns } from "./mobileFirst.vue?vue&type=template&id=28107916&scoped=true"
import script from "./mobileFirst.vue?vue&type=script&lang=ts"
export * from "./mobileFirst.vue?vue&type=script&lang=ts"
import style0 from "./mobileFirst.vue?vue&type=style&index=0&id=28107916&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28107916",
  null
  
)

export default component.exports